export default {
  text: [
    v => !!v || 'Opis zmian jest wymagany',
    v => v && v.length >= 10 || 'Opis zmian musi mieć co najmniej 10 znaków',
    v => v && v.length <= 200 || 'Opis zmian może mieć maksymalnie 200 znaków',
  ],
}